import 'core-js/stable';
import '@babel/polyfill';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import AppPage from './pages/AppPage';
import theme from './theme/theme';
import MailingSite from './MailingSite';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import ResetPasswordPage from './ResetPasswordPage';
import DashboardPage from './pages/Dashboard';
import ApplicationPage from './pages/ApplicationPage';

function noop() {}

if (process.env.NODE_ENV === 'production') {
  console.log = noop;
  console.error = noop;
  console.warn = noop;
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <Switch>
          <Route path="/dashboard" component={DashboardPage} />
          <Route path="/application">
            <AppPage />
          </Route>
          <Route path="/register">
            <RegisterPage />
          </Route>
          <Route path="/reset-password">
            <ResetPasswordPage />
          </Route>
          <Route path="/login">
            <LoginPage />
          </Route>
          <Route path="/join" component={ApplicationPage} />
          <Route path="/">
            <MailingSite />
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
